import { render } from "./TestResultWrapper.vue?vue&type=template&id=9caf9ff8"
import script from "./TestResultWrapper.vue?vue&type=script&lang=js"
export * from "./TestResultWrapper.vue?vue&type=script&lang=js"

import "./TestResultWrapper.vue?vue&type=style&index=0&id=9caf9ff8&lang=scss"

import exportComponent from "/builds/2022/edf_re_aos/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__